import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { CommonModule, NgFor, NgIf, NgOptimizedImage } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatDrawer, MatSidenavModule } from "@angular/material/sidenav";
import { Subject, Subscription, takeUntil } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import * as _moment from "moment";
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from "moment";
import { DynamicSettingsService } from "app/layout/common/dynamic-settings/dynamic-settings.service";
import { ModalComponent } from "app/modules/shared/modal.component";
import { ModalService } from "app/_services/modal.service";
import { DynamicFormComponent } from "app/modules/shared/forms/dynamic-form/dynamic-form.component";
import { FuseConfirmationService } from "@fuse/services/confirmation";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { UserService } from "app/core/user/user.service";
import { fuseAnimations } from "@fuse/animations";
import { cloneDeep } from "lodash";
import { KeyPairsComponent } from "app/modules/shared/key-pairs/key-pairs.component";
import { GridsComponent } from "app/modules/shared/grids/grids.component";
import { TableComponent } from "app/modules/shared/table/table.component";
import { FuseScrollbarDirective } from "@fuse/directives/scrollbar";
import { MaterialModule } from "app/material.module";
import { AppFilterPipeModule } from "app/_filters/app.filter-pipe.module";
import { FuseAlertComponent } from "@fuse/components/alert";
import { CommonService } from "app/_services/common.service";
import { LoaderService } from "app/_services/loader.service";
import { BaseRequestService } from "app/_services/base.service";
import { MyToastrService } from "app/_services/toastr.service";
import { DomainDetailsComponent } from "../domain-details/domain-details.component";

const moment = _rollupMoment || _moment;

@Component({
  selector: "app-trial-partners",
  standalone: true,
  imports: [
    CommonModule,
    GridsComponent,
    KeyPairsComponent,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    ModalComponent,
    TableComponent,
    FuseScrollbarDirective,
    MaterialModule,
    AppFilterPipeModule,
    DynamicFormComponent,
    FuseAlertComponent,
    NgIf,
    NgFor,
    ReactiveFormsModule,
    FormsModule,
    DomainDetailsComponent
  ],
  templateUrl: "./trial-partners.component.html",
  styleUrls: ["./trial-partners.component.scss"],
})
export class TrialPartnersComponent {
  partnerstatsData: any;
  tenantUserDetailsData: any;
  domainDetails: any;
  emailData: any;
  partnerstatsDataValue: any = [];
  fromDateField: any = null;
  todayField: Date = new Date();
  toDateField: any = null;
  @ViewChild("drawer") drawer: MatDrawer;
  drawerPosition: "start" | "end" = "end";
  drawerMode: "over" | "side" = "side";
  drawerOpened: boolean = false;
  cAsset: any;
  today: string;
  convertToPaidData: any;
  maxDate: string;
  changeDistributorData: any;
  extendTrailData: any;
  tenantUserDetails: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  trailPartnersTableOptions: any = {};
  trailActionView = "";
  companyId: any;
  distributorData: any;
  private subs: Subscription;
  private site: Subscription;
  addAsset: any = {};
  addExtendTrial: any = {};
  addconvertToPaid: any = {};
  scanAsset: any = {};
  importance: any = [
    { key: "Low", value: "25" },
    { key: "Medium", value: "50" },
    { key: "High", value: "75" },
    { key: "Critical", value: "100" },
  ];
  formElements: any = [
    {
      name: "distributor",
      description: "Choose Distributor",
      required: true,
      options: this.importance,
      schema: {
        type: "dropdown",
      },
    },
    {
      name: "reason",
      description: "Reason",
      required: true,
      schema: {
        type: "textarea",
      },
    },
  ];
  convertToPayformElements: any = [
    {
      name: "chooseDate",
      description: "Choose Date",
      required: true,
      schema: {
        type: "datepicker",
      },
    },
    {
      name: "reason",
      description: "Reason",
      required: true,
      schema: {
        type: "textarea",
      },
    },
  ];
  extendtrialFormElements: any = [
    {
      name: "trail",
      description: "Trail Days",
      required: true,
      schema: {
        type: "number",
      },
    },
    {
      name: "reason",
      description: "Reason",
      required: true,
      schema: {
        type: "textarea",
      },
    },
  ];
  scanTypeList = [
    { key: "Full Scan", value: 1 },
    { key: "Asset Scan", value: 2 },
    { key: "Active Directory Scan", value: 5 },
    { key: "SNMP Scan", value: 6 },
    { key: "LightWeight Agent Scan", value: 7 },
    { key: "Firewall Scan", value: 8 },
    { key: "PII Scan", value: 9 },
  ];
  changedistributorForm = [];
  extendtrialForm = [];
  convertToPayForm = [];
  scanformElements: any;
  formScanElements: any = [
    {
      name: "scan_type",
      description: "Scan Type",
      example: "",
      required: true,
      searching: false,
      options: [
        { displayName: "Full Scan", value: "FULLSCAN" },
        { displayName: "Active Directory Scan", value: "ADSCAN" },
        { displayName: "Network Scan", value: "NETWORKSCAN" },
      ],
      schema: {
        type: "dropdown",
        key: "displayName",
        value: "value",
      },
    },
  ];
  checkDistributorID: any;
  suppressData: any = {};
  internalUsers: any = [];

  fromDate = new Date();
  suspendPartnerdata: any;
  fromMinEndDate: any = null;
  currentUser: any = "";
  reasonsList: string[] = [
    "Justified for business reasons",
    "False Positive",
    "Compensating control in place",
    "Other",
  ];
  /**
   * Constructor
   */
  constructor(
    private cs: CommonService,
    private loaderService: LoaderService,
    private route: ActivatedRoute,
    private _ds: DynamicSettingsService,
    private _bs: BaseRequestService,
    public _modalService: ModalService,
    public _userService: UserService,
    private toast: MyToastrService,
    public confirmDialog: FuseConfirmationService,
    private _changeDetectorRef: ChangeDetectorRef,
  ) {
    this.today = new Date().toISOString().split('T')[0];
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 14);
    this.maxDate = maxDate.toISOString().split('T')[0];
    this.subs = this._ds.trailPartners.subscribe((res: any) => {
      if (res.target === 'check-email') {
        this._modalService.open("checkTrailEmailDetails");
      } else {
        this.assetActionCall(res);
      }
      // if (res.target === "extend-trial") {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.extendTrailData = this.cs.selectedTableRows[0];
      //     this.viewExtendtrial();
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
      // if (res.target === "change-distributor") {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.changeDistributorData = this.cs.selectedTableRows[0];
      //     this.viewDistributor();
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
      // if (res.target === 'tenant-user-details') {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.tenantUserDetailsData = this.cs.selectedTableRows[0];
      //     this.trailActionView = "tenant-user-details";
      //     this.viewuserDistributor();
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
      // if (res.target === "partner-stats") {
      //   if (
      //     (this.cs.selectedTableRows && this.cs.selectedTableRows.length)
      //   ) {
      //     this.trailActionView = "partner-stats";
      //     this.partnerstatsData = this.cs.selectedTableRows[0];
      //     this.changePertnerStats();
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
      // if (res.target === "convert-to-paid") {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.convertToPaidData = this.cs.selectedTableRows[0]
      //     this.convertToPaid();
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
      // if (res.target === "suspend-partner") {
      //   if (this.cs.selectedTableRows && this.cs.selectedTableRows.length) {
      //     this.suspendPartnerdata = this.cs.selectedTableRows[0]
      //     this.openSuspendPartner()
      //   } else {
      //     this.toast.sToast("info", "Please select at least one asset.");
      //   }
      // }
    });
    this.cs.afterAddPartner.pipe(takeUntil(this._unsubscribeAll))
      .subscribe((res: any) => {
        this.cs.checkDistributorID = res;
        let data = Object.assign({}, this.trailPartnersTableOptions);
        this.trailPartnersTableOptions = {};
        this._changeDetectorRef.detectChanges();
        data.pageData = []; data.tableOptions.pageTotal = 0;
        if (this.cs.currentScope !== '*') {
          data.tableOptions.serverSide.condition = `distributor_id=${parseInt(this.cs.currentScope.id)}`;
        } else {
          data.tableOptions.serverSide.condition = '';
        }
        this.trailPartnersTableOptions = data; this._changeDetectorRef.detectChanges();
        if (this.drawer.opened) {
          this.drawer.toggle().then((r) => console.log(r));
        }
      });
    this.site = this.cs.selectedSiteChanged.subscribe((cmp: any) => {
      this.cs.checkDistributorID = cmp;
      let data = Object.assign({}, this.trailPartnersTableOptions);
      this.trailPartnersTableOptions = {};
      this._changeDetectorRef.detectChanges();
      data.pageData = []; data.tableOptions.pageTotal = 0;
      if (this.cs.currentScope !== '*') {
        data.tableOptions.serverSide.condition = `distributor_id=${parseInt(this.cs.currentScope.id)}`;
      } else {
        data.tableOptions.serverSide.condition = '';
      }
      this.trailPartnersTableOptions = data; this._changeDetectorRef.detectChanges();
      if (this.drawer.opened) {
        this.drawer.toggle().then((r) => console.log(r));
      }
    });
    try {
      this.route.data.subscribe((v: any) => {
        this.trailPartnersTableOptions = {
          columns: [
            {
              header: "Distributor",
              columnDef: "distributor_name",
              cType: "string",
              filter: "checkingnull",
              cell: "(element: any) => `${element.distributor_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Tenant Name",
              columnDef: "tenant_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.tenant_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Status",
              columnDef: "subscription_status",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.subscription_status}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Assets Count",
              columnDef: "asset_size",
              cType: "number",
              filter: "",
              cell: "(element: any) => `${element.asset_size}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Version",
              columnDef: "version",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.version}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "First Name",
              columnDef: "first_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.first_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Last Name",
              columnDef: "last_name",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.last_name}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Cloud Region",
              columnDef: "region",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.region}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Email",
              columnDef: "email",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.email}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Domain",
              columnDef: "domain",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.domain}`",
              order: 0,
              isHyperlink: true,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            // {
            //   header: "Sub Distributor",
            //   columnDef: "sub_distributor",
            //   cType: "string",
            //   filter: "",
            //   cell: "(element: any) => `${element.sub_distributor}`",
            //   order: 0,
            //   visible: true,
            //   isToolTip: false,
            //   isToolTipCol: "",
            //   hasMultiData: false,
            //   class: "",
            //   color: "",
            //   isProgressCntrl: false,
            //   isColoredCntrl: false,
            //   colList: [],
            //   isfaicon: false,
            //   isAddingText: false,
            //   addingText: "",
            //   img: false,
            //   imgPath: "",
            //   isSort: true,
            //   iscolumnSearch: false,
            // },
            {
              header: "Paid Since",
              columnDef: "paid_start_date",
              cType: "string",
              filter: "utcToLocale",
              width: '140px',
              cell: "(element: any) => `${element.paid_start_date}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Hosted By",
              columnDef: "hosted_by",
              cType: "string",
              filter: "",
              cell: "(element: any) => `${element.hosted_by}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "POD ID",
              columnDef: "pod_id",
              cType: "number",
              filter: "checkingnull",
              cell: "(element: any) => `${element.pod_id}`",
              order: 0,
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Created",
              columnDef: "created",
              cType: "",
              filter: "utcToLocale",
              cell: "(element: any) => `${element.created}`",
              order: 0,
              width: "140px",
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Last Login Time",
              columnDef: "last_login_time",
              cType: "",
              filter: "utcToLocale",
              cell: "(element: any) => `${element.last_login_time}`",
              order: 0,
              width: "140px",
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
            {
              header: "Trial Ends On",
              columnDef: "trial_end_date",
              cType: "",
              filter: "utcToLocale",
              cell: "(element: any) => `${element.trial_end_date}`",
              order: 0,
              width: "140px",
              visible: true,
              isToolTip: false,
              isToolTipCol: "",
              hasMultiData: false,
              class: "",
              color: "",
              isProgressCntrl: false,
              isColoredCntrl: false,
              colList: [],
              isfaicon: false,
              isAddingText: false,
              addingText: "",
              img: false,
              imgPath: "",
              isSort: true,
              iscolumnSearch: false,
            },
          ],
          sortOptions: { active: "tenant_name", direction: "asc" },
          _pageData: [],
          tableOptions: {
            title: "Trial Partners",
            isServerSide: false,
            selectText: "trailpartners(s)",
            loading: true,
            floatingFilter: true,
            rowSelection: false,
            showAction: true,
            actionMenuItems: [
              {
                name: "Tenant User Details",
                text: "Tenant User Details",
                id: "tenant-user-details",
                icon: "heroicons_mini:user-group",
                target: "tenant-user-details",
                emtterAction: "trailPartners",
                isGlobal: false,
                callback: 'editFunction',
              },
              {
                name: "Extend Trial",
                text: "Extend Trial",
                id: "extend-trial",
                icon: "mat_outline:file_present",
                target: "extend-trial",
                emtterAction: "trailPartners",
                isGlobal: false,
                callback: 'editFunction',
              },
              {
                name: "Change Distributor",
                text: "Change Distributor",
                id: "change-distributor",
                icon: "mat_outline:file_copy",
                target: "change-distributor",
                emtterAction: "trailPartners",
                isGlobal: false,
                callback: 'editFunction',
              },
              {
                name: "Partner Stats",
                text: "Partner Stats",
                id: "partner-stats",
                icon: "mat_outline:info",
                target: "partner-stats",
                emtterAction: "trailPartners",
                isGlobal: false,
                callback: 'editFunction',
              },
              {
                name: "Convert To Paid",
                text: "Convert To Paid",
                id: "convert-to-paid",
                icon: "mat_outline:verified",
                target: "convert-to-paid",
                emtterAction: "trailPartners",
                isGlobal: false,
                callback: 'editFunction',
              },
              {
                name: "Suspend Partner",
                text: "Suspend Partner",
                id: "suspend-partner",
                icon: "mat_outline:delete_sweep",
                target: "suspend-partner",
                emtterAction: "trailPartners",
                isGlobal: false,
                callback: 'editFunction',
              },
            ],
            pagination: true,
            pageOptions: [5, 10, 25, 100],
            pageSize: 10,
            search: false,
            saveData: true,
            showhideList: true,
            refreshData: true,
            showFilter: true,
            showTagFilter: false,
            exportExcel: true,
            add: false,
            columnSearch: false,
            compareData: false,
            filterDownload: false,
            isNotSiteChange: true,
            serverSide: {
              url: "/r/report_queries/partner_status",
              condition: ``,
              type: "post",
              isGlobal: true,
              params: { subscription_status: 'Trial' },
            },
          },
          changeValue: new Subject<any>(),
        };
      });
    } catch (error) {
      console.error("Error retrieving route data:", error);
    }
  }

  ngOnInit(): void {
    if (this.cs.currentScope !== "*") {
      this.trailPartnersTableOptions.tableOptions.serverSide.condition = `distributor_id=${this.cs.currentScope.id}`;
    } else if (this.cs.currentScope === "*") {
      this.trailPartnersTableOptions.tableOptions.serverSide.condition = `true`
    } else {
      this.trailPartnersTableOptions.tableOptions.serverSide.condition = `true`
    }
    this._userService.userd$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((user: any) => {
        this.currentUser = user["email"];
      });
    this.scanformElements = this.cs.processFormElements(this.formScanElements);
  }



  changeEvent(event: any) {
    this.fromMinEndDate = this.cs.getLastDay(1, event.value);
  }
  assetActionCall(res: any): void {
    const tableName: any = this.trailPartnersTableOptions.tableOptions.title;
    if (res.target === "extend-trial") {
      if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
        this.extendTrailData = this.cs.selectedTableRows[tableName][0];
        this.extendTrailData.trial_start_date = this.today;
        this.viewExtendtrial();
      } else {
        this.toast.sToast("info", "Please select at least one asset.");
      }
    }
    if (res.target === "change-distributor") {
      if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
        this.changeDistributorData = this.cs.selectedTableRows[tableName][0];
        this.viewDistributor();
      } else {
        this.toast.sToast("info", "Please select at least one asset.");
      }
    }
    if (res.target === 'tenant-user-details') {
      if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
        this.tenantUserDetailsData = this.cs.selectedTableRows[tableName][0];
        this.trailActionView = "tenant-user-details";
        this.viewuserDistributor();
      } else {
        this.toast.sToast("info", "Please select at least one asset.");
      }
    }
    if (res.target === "partner-stats") {
      if (
        (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length)
      ) {
        this.trailActionView = "partner-stats";
        this.partnerstatsData = this.cs.selectedTableRows[tableName][0];
        this.changePertnerStats();
      } else {
        this.toast.sToast("info", "Please select at least one asset.");
      }
    }
    if (res.target === "convert-to-paid") {
      if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
        this.convertToPaidData = this.cs.selectedTableRows[tableName][0]
        this.convertToPaid();
      } else {
        this.toast.sToast("info", "Please select at least one asset.");
      }
    }
    if (res.target === "suspend-partner") {
      if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
        this.suspendPartnerdata = this.cs.selectedTableRows[tableName][0]
        this.openSuspendPartner()
      } else {
        this.toast.sToast("info", "Please select at least one asset.");
      }
    }
    // if (res.target === "change-distributor") {
    //   if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
    //     this.changeDistributorData = this.cs.selectedTableRows[tableName][0];
    //     this.viewDistributor();
    //   } else {
    //     this.toast.sToast("info", "Please select at least one asset.");
    //   }
    // }
    // if (res.target === 'tenant-user-details') {
    //   this.tenantUserDetailsData = null;
    //   if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
    //     this.tenantUserDetailsData = this.cs.selectedTableRows[tableName][0];
    //     this.trailActionView = "tenant-user-details";
    //     this.viewuserDistributor();
    //   } else {
    //     this.toast.sToast("info", "Please select at least one asset.");
    //   }
    // }
    // if (res.target === "partner-stats") {
    //   if (
    //     (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length)
    //   ) {
    //     this.trailActionView = "partner-stats";
    //     this.partnerstatsData = this.cs.selectedTableRows[tableName][0];
    //     this.changePertnerStats();
    //   } else {
    //     this.toast.sToast("info", "Please select at least one asset.");
    //   }
    // }
    // if (res.target === "convert-to-paid") {
    //   if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
    //     this.convertToPaidData = this.cs.selectedTableRows[tableName][0]
    //     this.convertToPaid();
    //   } else {
    //     this.toast.sToast("info", "Please select at least one asset.");
    //   }
    // }
    // if (res.target === "suspend-partner") {
    //   if (this.cs.selectedTableRows[tableName] && this.cs.selectedTableRows[tableName].length) {
    //     this.suspendPartnerdata = this.cs.selectedTableRows[tableName][0]
    //     this.openSuspendPartner()
    //   } else {
    //     this.toast.sToast("info", "Please select at least one asset.");
    //   }
    // }
  }
  actionCall(data: any) {
    const tableName: any = this.trailPartnersTableOptions.tableOptions.title;
    this.cs.selectedTableRows[tableName] = [data.row];
    this.assetActionCall(data.action);
  }
  linkClick(event: any) {
    if (event.col === "domain") {
      let skip = 0;
      let condition: any =
        this.cs.currentScope === '*'
          ? { condition: true, skip, limit: 100, tenant_id: event.row.tenant_id }
          : { condition: `distributor_id=${this.cs.currentScope.id}`, skip, limit: 100, tenant_id: event.row.tenant_id };

      this._bs
        .doRequest("/r/report_queries/partner_stats", "get", null, condition)
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe((result: any) => {
          if (result.status) {
            this.domainDetails = result.data;
            if (this.domainDetails.length > 0) {
              this.viewDomainDetails();
            } else {
              this.toast.sToast("error", 'No Data Found');
            }
          }
        });
    }
  }
  closeMethod() {
    this.tenantUserDetailsData = null;
    this.drawerOpened = false
  }
  viewDomainDetails() {
    this.drawerOpened = true;
    this.trailActionView = "domain-details";
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }
  tabFnDetails($event: any): void {
    if ($event === 1) {
      // this.changePertnerStats(true)
    }
  }
  viewExtendtrial() {
    // this.loaderService.display(true);
    // this.cAsset = asset;
    this.trailActionView = "extend-trial";
    this.drawerOpened = true;
    // const formElements = [...this.extendtrialFormElements];
    // this.addExtendTrial = {};
    // this.extendtrialForm = this.cs.processFormElements(formElements);
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }
  viewPartnerSattus() {
    this.trailActionView = "partner-stats";
    this.drawerOpened = true;
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }
  convertToPaid() {
    this.trailActionView = "convert-to-paid";
    this.drawerOpened = true;
    // const formElements = [...this.convertToPayformElements];
    // this.addconvertToPaid = {};
    // this.convertToPayForm = this.cs.processFormElements(formElements);
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }
  formatDate(date: any) {
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    let day = String(date.getDate()).padStart(2, '0');
    const formattedDateString = `${year}-${month}-${day}`;
    const parsedDate = new Date(formattedDateString);
    const formattedDate = `${parsedDate.getFullYear()}-${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}-${parsedDate.getDate().toString().padStart(2, '0')}`;
    return formattedDate;
  }
  changePertnerStats(value?: any): void {
    let datavalue;
    let skip = 0;
    if (this.fromDateField && this.toDateField) {
      datavalue = `created::date BETWEEN '${this.formatDate(this.fromDateField)}' AND '${this.formatDate(this.toDateField)}'`;
    } else if (this.fromDateField) {
      datavalue = `created::date >= '${this.formatDate(this.fromDateField)}'`;
    } else if (this.toDateField) {
      datavalue = `created::date <= '${this.formatDate(this.toDateField)}'`;
    }
    let condition: any;
    condition =
      this.cs.currentScope === '*'
        ? { condition: (datavalue) ? datavalue : true, skip, limit: 100, tenant_id: this.partnerstatsData.tenant_id }
        : { condition: (datavalue) ? `${datavalue} and distributor_id=${this.cs.currentScope.id}` : `distributor_id=${this.cs.currentScope.id}`, skip, limit: 100, tenant_id: this.partnerstatsData.tenant_id };

    this._bs
      .doRequest("/r/report_queries/partner_stats_view", "get", null, condition)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          this.partnerstatsDataValue = result.data;
          if (this.partnerstatsDataValue.length > 0) {
            this.viewPartnerSattus();
          } else {
            if (!value) {
              this.toast.sToast("error", 'No data Found');
            }
          }
        } else {
          this.toast.sToast("error", 'No data Found');
          this.partnerstatsDataValue = [];
        }
      });
  }
  downloaddata() {
    const condition = {
      condition: true,
      skip: 0,
      limit: 500,
      file_name: 'partner_stats.csv',
      tenant_id: this.partnerstatsData.tenant_id
    };
    this._bs
      .doRequest("/r/report_queries/partner_stats_view", "get", null, condition)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          window.open(result.message, '_blank');
          this.toast.sToast("success", 'Data Downloaded Sucesfully');
        } else {
          this.toast.sToast("error", 'No data Found');
        }
      });
  }
  resetDate() {
    this.fromDateField = null;
    this.toDateField = null;
    this.changePertnerStats()
  }
  openSuspendPartner() {
    this._modalService.open("suspendPartner");
  }
  viewuserDistributor() {
    this.drawerOpened = true;
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }
  viewDistributor() {
    // this.loaderService.display(true);
    // this.cAsset = asset;
    this.trailActionView = "change-distributor";
    this.drawerOpened = true;
    this.getCompanies()
    // const formElements = [...this.formElements];
    // this.addAsset = {};
    // this.changedistributorForm = this.cs.processFormElements(formElements);
    if (!this.drawer.opened) {
      this.drawer.toggle().then((r) => console.log(r));
    }
  }

  filterTags($event: any): void {
    // console.log($event);
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this.subs.unsubscribe();
    this.site.unsubscribe();
  }

  tabFn($event: any): void {
    switch ($event) {
      case 0:
        const data = Object.assign({}, this.trailPartnersTableOptions);
        this.trailPartnersTableOptions = {};
        this.trailPartnersTableOptions.pageData = [];
        this.trailPartnersTableOptions.tableOptions.pageTotal = 0;
        data.pageData = [];
        data.tableOptions.pageTotal = 0;
        this.trailPartnersTableOptions = data;
        break;
      default:
        break;
    }
  }

  toggleChange($event: any): void {
    this.cs.selctedAsset = "";
    this.drawer.toggle();
  }
  saveConvertPaid(convertToPaidData) {
    const request: any = {};
    request.id = convertToPaidData.id;
    request.tenant_id = convertToPaidData.tenant_id;
    request.data = {
      paid_start_date: this.formatDate(convertToPaidData.paid_start_date),
      subscription_status: "Paid",
    }
    request.reason = convertToPaidData.reason
    request.action = "Convert to Paid"
    // if (this.cs.currentScope !== "*") {
    //   request.distributor_id = this.cs.currentScope.id;
    // }
    this.loaderService.display(true);
    this._bs
      .doRequest(`/w/partners/tenant`, "patch", request)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "Convert to Paid Updated successfully!");
          this.drawerOpened = false; setTimeout(() =>
            this.trailPartnersTableOptions.changeValue.next(true)
          );
        } else {
          this.toast.sToast("error", result.message);
        }
      });
  }
  saveExtent(extendTrailData) {
    console.log('extendTrailData', extendTrailData);
    const request: any = {};
    request.id = extendTrailData.id;
    request.tenant_id = extendTrailData.tenant_id;
    request.data = {
      trial_end_date: this.formatDate(extendTrailData.trial_end_date),
    }
    request.reason = extendTrailData.reason;
    request.action = "Trial Extension"
    // if (this.cs.currentScope !== "*") {
    //   request.distributor_id = this.cs.currentScope.id;
    // }
    this.loaderService.display(true);
    this._bs
      .doRequest(`/w/partners/tenant`, "patch", request)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "Trial Extended successfully!");
          this.drawerOpened = false; setTimeout(() =>
            this.trailPartnersTableOptions.changeValue.next(true)
          );
        } else {
          this.toast.sToast("error", result.message);
        }
      });
  }
  getCompanies(search?: string): void {
    const condition = search
      ? { condition: "distributor_name ilike '%" + search + "%'" }
      : {
        condition: true,
        skip: 0,
        limit: 100,
        order_by: "distributor_name asc",
      };
    this._bs
      .doRequest("/r/distributors/distributors", "get", null, condition)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          this.distributorData = result.data;
        }
      });
  }
  saveDistributor(changeDistributorData?: any): void {
    const request: any = {};
    request.id = changeDistributorData.id;
    request.tenant_id = changeDistributorData.tenant_id;
    request.data = {
      distributor_id: changeDistributorData.distributor_id,
    };
    request.reason = changeDistributorData.reason;
    request.action = "Change Distributor";
    // if (this.cs.currentScope !== "*") {
    //   request.distributor_id = this.cs.currentScope.id;
    // }
    this.loaderService.display(true);
    this._bs
      .doRequest(`/w/partners/tenant`, "patch", request)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "Distributor Changed successfully!");
          this.drawerOpened = false;
          // this._modalService.close("changeDistributorModal");
          setTimeout(() => this.trailPartnersTableOptions.changeValue.next(true));
        } else {
          this.toast.sToast("error", result.message);
        }
      });
  }

  saveAsset($event: any): void {
    const request: any = $event;
    if (this.cs.currentScope !== "*") {
      request.distributor_id = this.cs.currentScope.id;
    }
    this.loaderService.display(true);
    this._bs
      .doRequest(`w/asset/assets`, "post", { data: request })
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "Asset added successfully!");
          this._modalService.close("addNewAssetModal");
          setTimeout(() =>
            this.trailPartnersTableOptions.changeValue.next(true)
          );
        } else {
          this.toast.sToast("error", result.message);
        }
      });
  }
  saveSuspendPartner(suspendPartnerdata?: any) {
    const request: any = {};
    request.id = suspendPartnerdata.id;
    request.tenantid = suspendPartnerdata.tenant_id;
    request.reason = suspendPartnerdata.reason;
    request.action = "Partner Suspend";
    request.subscription_status = "Suspended";
    this.loaderService.display(true);
    this._bs
      .doRequest(`/w/partners/suspend`, "post", request)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        this.loaderService.display(false);
        if (result.status) {
          this.toast.sToast("success", "Suspend Partner successfully!");
          // this.drawerOpened = false;
          this._modalService.close("suspendPartner");
          setTimeout(() => this.trailPartnersTableOptions.changeValue.next(true));
        } else {
          this.toast.sToast("error", result.message);
        }
      });
  }
  SuspendPartner($event: any): void {
    const confirmation = this.confirmDialog.open({
      title: "Confirmation",
      message: `Are you sure you want to Suspend Partner`,
      actions: {
        confirm: {
          label: "Yes",
        },
      },
    });
    confirmation.afterClosed().subscribe((result) => {
      if (result === "confirmed") {
        const reqData: any = {
          tenantid: this.cs.selectedTableRows.map((obj: any) => obj.tenant_id),
        };
        reqData.action = "Partner Suspend";
        this._bs
          .doRequest(`/w/partners/suspend`, "post", reqData)
          .pipe(takeUntil(this._unsubscribeAll))
          .subscribe((result: any) => {
            if (result.status) {
              this.toast.sToast("success", "Suspend Partner successfully");
              setTimeout(() =>
                this.trailPartnersTableOptions.changeValue.next(true)
              );
            } else {
              this.toast.sToast("error", result.message);
            }
          });
      }
    });
  }
  checkEmailDeatilsValue(){
    this._modalService.open("tenantUserDetails");
  }
  checkEmail(data: any) {
    let condition = {
      tenantid: "",
      user_email: data
    }

    this._bs.doRequest(`/w/partners/user_exists`, 'post', condition)
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((result: any) => {
        if (result.status) {
          this.toast.sToast('success', result.message);
          this.tenantUserDetails = result;
          this.tenantUserDetails.message = this.tenantUserDetails.message.replace(/"/g, '');
          setTimeout(() => {
            this.trailPartnersTableOptions.changeValue.next(true);
          }, 3000);
          this.emailData = null;
          this._modalService.close("checkTrailEmailDetails");
          this.checkEmailDeatilsValue()
          setTimeout(() => {
            this.checkEmailDeatilsValue()
          }, 3000);
        } else {
          const data = (result.message) ? result.message : result.data;
          this.toast.sToast('error', data);
        }
      });
  }

}
